import { configureStore } from "@reduxjs/toolkit"
import AuthReducer from "./reducers/AuthReducer"
import layoutReducer from "./reducers/LayoutReducer";
import masterReducer from "./reducers/MasterReducer";
import geofenceReducer from "./reducers/GeofenceReducer";
import productReducer from "./reducers/ManageProductReducer"
import enquiryReducer from "./reducers/EnquiryReducer";
import supplierReducer from "./reducers/SupplierReducer";
import projectReportReducer from "./reducers/ProjectReportReducer";

import {thunk} from 'redux-thunk';
const Store = configureStore({
    reducer: {
        AuthReducer, 
        layoutReducer,
        masterReducer,
        geofenceReducer,
        productReducer,
        enquiryReducer,
        supplierReducer,
        projectReportReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
})

export default Store